import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Container, Button, Row, Badge, Col } from 'reactstrap';
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { IUser } from 'app/shared/model/user.model';
import { getUser } from './user-management.reducer';
import { IRootState } from 'app/shared/reducers';

export interface IUserManagementDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ login: string }> {}

export class UserManagementDetail extends React.Component<IUserManagementDetailProps> {
  componentDidMount() {
    this.props.getUser(this.props.match.params.login);
  }

  render() {
    const { user } = this.props;
    return (
      <div>
        <h2>
          User [<b>{user.login}</b>]
        </h2>
        <Container>
          <Row>
            <Col md="2">
              <dt>Login</dt>
            </Col>
            <Col md="2">
              <dd>
                <span>{user.login}</span>&nbsp;
                {user.activated ? <Badge color="success">Activated</Badge> : <Badge color="danger">Deactivated</Badge>}
              </dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>First Name</dt>
            </Col>
            <Col md="2">
              <dd>{user.firstName}</dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Last Name</dt>
            </Col>
            <Col md="2">
              <dd>{user.lastName}</dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Email</dt>
            </Col>
            <Col md="2">
              <dd>{user.email}</dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Created By</dt>
            </Col>
            <Col md="2">
              <dd>{user.createdBy}</dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Created Date</dt>
            </Col>
            <Col md="2">
              <dd>
                <TextFormat value={user.createdDate} type="date" format={APP_DATE_FORMAT} blankOnInvalid />
              </dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Last Modified By</dt>
            </Col>
            <Col md="2">
              <dd>{user.lastModifiedBy}</dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Last Modified Date</dt>
            </Col>
            <Col md="2">
              <dd>
                <TextFormat value={user.lastModifiedDate} type="date" format={APP_DATE_FORMAT} blankOnInvalid />
              </dd>
            </Col>
          </Row>
          <Row>
            <Col md="2">
              <dt>Profiles</dt>
            </Col>
            <Col md="2">
              <dd>
                <ul className="list-unstyled">
                  {user.authorities
                    ? user.authorities.map((authority, i) => (
                        <li key={`user-auth-${i}`}>
                          <Badge color="info">{authority}</Badge>
                        </li>
                      ))
                    : null}
                </ul>
              </dd>
            </Col>
          </Row>
        </Container>
        <Button style={{ float: 'right', margin: '20px' }} tag={Link} to="/admin/user-management" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  user: storeState.userManagement.user
});

const mapDispatchToProps = { getUser };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(UserManagementDetail);
